// ============================================================
// Zugehörigkeit zu einem Büro (SPEC §14.2).
//
// Seit 009 hat ein Mensch ein HEIMATBÜRO (`buero_id`) und beliebig viele
// WEITERE (`weitere_bueros`). Die beiden Begriffe fallen auseinander, und
// welcher gemeint ist, hängt an der Frage:
//
// * „Wo steht der Avatar?" — immer das Heimatbüro. Einen Platz auf einer
//   Karte kann man nur einmal haben, und der Ring trägt seine Farbe.
// * „Gehört sie dazu?" — Heimat ODER Zweitbüro. Das ist der Bürofilter, die
//   Mitgliederliste der Büroseite und die Kopfzahl an der Ortsmarke.
//
// Die zweite Frage steht hier und nicht dreimal als `p.buero_id === id ||
// p.weitere_bueros.includes(id)` in drei Bildschirmen — die vierte Stelle
// hätte sonst die Hälfte davon vergessen.
// ============================================================

/** Das Wenige, was diese Funktionen von einer Person brauchen. */
export interface BueroZugehoerig {
  buero_id: string | null;
  weitere_bueros: string[];
}

/** Gehört diese Person zu dem Büro — als Heimat ODER als Zweitbüro? */
export function gehoertZuBuero(person: BueroZugehoerig, bueroId: string): boolean {
  return person.buero_id === bueroId || person.weitere_bueros.includes(bueroId);
}

/** Gehört sie dazu, ohne hier ihr Heimatbüro zu haben? Das ist das „auch". */
export function istZweitbuero(person: BueroZugehoerig, bueroId: string): boolean {
  return person.buero_id !== bueroId && person.weitere_bueros.includes(bueroId);
}

/** Trifft eine Büroauswahl (mehrere Kennungen, leer = alle) diese Person? */
export function passtZuBuerofilter(person: BueroZugehoerig, bueroIds: readonly string[]): boolean {
  if (bueroIds.length === 0) return true;
  return bueroIds.some((id) => gehoertZuBuero(person, id));
}
